module.exports = __webpack_public_path__ + "ws.2525988cde30154d25f7.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ws.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ws.svg
// module chunks = styles